<template>
	<span :class="preCls + 'time-clock'">
		{{ formatTime }}
	</span>
</template>
<script>
import { toDate } from '_u/helper'
import dayjs from 'dayjs'

export default {
	name: "TimeClock",

	props: {
		// 起始时间
		value: {
			type: [Date, Number, String],
		},
		// 时间格式
		format: {
			type: String,
			default: "YYYY-MM-DD HH:mm:ss"
		}
	},

	data() {
		return {
			counter: null,
			time: this.value,
		}
	},

	computed: {
		formatTime() {
			return this.time.format(this.format)
		},
	},

	created() {
		this.time = dayjs(this.value ? toDate(this.value) : new Date())

		var lastTime = this.time.valueOf()

		this.counter = setInterval(() => {
			var now = new Date().getTime()

			this.time = this.time.add(Math.floor((now - lastTime) / 1000), 'second')
			lastTime = now
		}, 1000)
	},

	beforeDestroy() {
		clearInterval(this.counter)
		this.counter = null
	},
}
</script>
<style lang="less"
    scoped>
@time-clock-prefix-cls: ~"@{css-prefix}-time-clock";

.@{time-clock-prefix-cls} {
	display: inline-block;
}
</style>